import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'antd';
import Markdown from '../../../components/Markdown';
import {
  Wrap,
  Title,
  SubTitle,
  StepWrap,
  Steplist,
  TopicsWrap,
  TopicsList,
  ButtonText,
  Text,
} from './Application.style';

const Application = ({ app }) => {
  return app ? (
    <Wrap id="application-section">
      {<Title>{app[0].title}</Title>}
      <SubTitle>{app[0].subtitle}</SubTitle>
      <StepWrap>
        {app[0].applicationSteps &&
          app[0].applicationSteps.map((item, index) => (
            <React.Fragment key={item.entryId}>
              {index !== 0 && <Icon type="forward" />}
              <Steplist key={index}>{item.title}</Steplist>
            </React.Fragment>
          ))}
      </StepWrap>
      <TopicsWrap>
        {app[0].topics.map(({ title, ctaLabel, ctaUrl, image, description, entryId }) => (
          <TopicsList key={entryId}>
            <div>
              <h6>{title}</h6>
              <Markdown src={description} Component={Text} />
              {ctaUrl && (
                <ButtonText href={ctaUrl} target="_blank">
                  {ctaLabel}
                </ButtonText>
              )}
            </div>
            {image && <img src={image.file.url} alt={image.title} />}
          </TopicsList>
        ))}
      </TopicsWrap>
    </Wrap>
  ) : null;
};

Application.defaultProps = {
  app: null,
};

Application.propTypes = {
  app: PropTypes.arrayOf(PropTypes.shape()),
};
export default Application;



// WEBPACK FOOTER //
// ./src/pages/SeminarSchedulePage/Application/Application.js